module.exports = __webpack_public_path__ + "img/logo.ee5081b2.png";